import { ActionBar, Box, Button } from '@ksyos/design-system';
import { translateKey } from '../../translate';
import { BadgeWithLabel } from '../elements/BadgeWithLabel';

interface IActionBarShowAndRemoveSelectionProps {
    handleClose: () => Promise<void>;
    handleDelete: () => Promise<void>;
    isOpen?: boolean;
    selectedIds: string[];
}

export function ActionBarShowAndRemoveSelection(props: IActionBarShowAndRemoveSelectionProps) {
    return (
        <ActionBar
            isOpen={props.isOpen}
            onClose={props.handleClose}
        >
            <Box
                alignItems="center"
                display="flex"
                gap={3}
                justifyContent="space-between"
            >
                <BadgeWithLabel
                    color="inverse"
                    label={translateKey('common.isSelected')}
                    value={props.selectedIds.length.toString()}
                />
                <Button
                    onClick={props.handleDelete}
                    variant="solid"
                >
                    {translateKey('common.remove')}
                </Button>
            </Box>
        </ActionBar>
    );
}
